module.exports = __webpack_public_path__ + "static/media/sidebar3.1a56d244.jpg";